import axios from 'axios';
// config
// import { HOST_API } from '../config';

// ----------------------------------------------------------------------

// CLIENT BASE URL
// export const BASED_URL = "https://api.shadowmatchbymedeire.com"
// DEV BASE URL
export const BASED_URL = "https://api.shadowmatch.dev-iuh.xyz"

const axiosInstance = axios.create({
  baseURL: BASED_URL
});


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
